// extracted by mini-css-extract-plugin
export default {"navigation__wrapper":"Navigation_navigation__wrapper__o2SkY"};